import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import {AuthorizationContext} from '../../context/authorizationContext';
import './home.css';
import HomePageImage from '../../assets/Home Page Image.jpg';

const Home = ()=>{
    const {flagLoggedin, userDetail, setPath} = React.useContext(AuthorizationContext);

    setPath(window.location.pathname);
    // console.log("Printing context in home.jsx", context);
    return (
        flagLoggedin !== true ? 
        <>
            <div className="home_section">
                <div className="left_section">
                    <h1>Welcome to OnBoard.!</h1>
                    <span>We helps to keep teams move ahead in work.</span>
                    <div className="d-flex flex-wrap">
                        <button>
                            <Link className="link" to="/login">Login</Link>
                        </button>
                    </div>
                </div>
                <div className="right_section">
                    <img src={HomePageImage} />
                </div>
            </div>
        </> : <>
            <div className="home_section">
                <div className="left_section">
                    <h1>Welcome {userDetail?.first_name} {userDetail?.last_name}.!</h1>
                    <p>{
                        userDetail?.admin ? "Manage your work and move ahead." : 
                    "View your work and move ahead."}</p>
                    <div className="d-flex flex-wrap">
                        <button>
                            <Link className="link" to="/tasks">Tasks</Link>
                        </button>
                    </div>
                </div>
                <div className='right_section'>
                    <img src={HomePageImage} />
                </div>
            </div>
        </>
    )
};

export default Home;